import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class OrderLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,

      filter_search: "",
      filter_start_date: format_date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        "yyyy-mm-dd",
        "en"
      ),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",
      filter_payment_type: "ชำระทันที",
      filter_status: "รอชำระ,รอสั่งสินค้า,ยกเลิก",

      data: [],
      data_warehouse: [],
      data_bank: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };

    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(0);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
    } = this.state;
    let data, data_warehouse, data_bank;
    loading(true);
    let [result, result_warehouse, result_bank] = await Promise.all([
      GET("admin/sales/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        status_code: "เสร็จสิ้น,ใบแจ้งหนี้",
      }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/banks/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      let result_product = await Promise.all(
        data.map((e) =>
          GET("admin/sales/list-payment", {
            data_search: e.document_no,
            payment_type: "",
          })
        )
      );

      data = data.map((e, i) => ({
        ...e,
        transaction_list: result_product[i].data,
      })).sort((a,b)=>a.updated_at - b.updated_at);
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_bank?.status) {
      data_bank = result_bank.data;
    }
    this.setState({
      data,
      data_warehouse,
      data_bank,
    });
    loading(false);
  };

  ExportPDF = async () => {
    const table = this.tableRef.current;
    if (!table) return [];

    const rows = Array.from(table.querySelectorAll("tbody tr"));

    const data_list = rows.map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td"));
      return cells.map((td) => td.innerText.trim());
    });

    let footer = false;
    const obj = {
          table: {
            headerRows: 0,
            widths: ["auto","auto","*","auto","auto","auto","auto"],
            body: [
              [
                { text: "วันที่", alignment: "center" },
                { text: "เลขที่เอกสาร", alignment: "center" },
                { text: "คลังสินค้า", alignment: "center" },
                { text: "จำนวนรวม", alignment: "center" },
                { text: "ภาษีมูลค่าเพิ่ม", alignment: "center" },
                { text: "จำนวนเงินรวมทั้งสิ้น", alignment: "center", colSpan: 2 },
                "",
              ],
              ...data_list.map((item, index) => {
                let border = [1, 0, 1, 0];
                let color = "#ffffff";
                if(index === data_list.length - 1){
                  border = [1, 0, 1, 1];
                }
                if(item[0]){
                  footer = false;
                  border = !item[0]?.includes("ลำดับ") ? [0, 1, 0, 0]: [1, 1, 1, 1];
                  color = data_list[index+1]?.includes("ลำดับ") ? "#d8d8d8": "#ffffff";
                  return [
                      { text: item[0] || " ", alignment: "center", fillColor: color, border: [1, border[1], border[2], border[3]] },
                      { text: item[1] || " ", alignment: "left", fillColor: color, border },
                      { text: item[2] || " ", alignment: "center", fillColor: color, border },
                      { text: item[3] || " ", alignment: "center", fillColor: color, border },
                      { text: item[4] || " ", alignment: "center", fillColor: color, border },
                      { text: item[5] || " ", alignment: "center", fillColor: color, border },
                      { text: item[6] || " ", alignment: "right", fillColor: color, border: [border[0], border[1], 1, border[3]] },
                    ]
                }
                else{
                   border = [1, 0, 1, 0];
                   if(!footer){
                     border = [1, 1, 1, 0];
                   }
                   footer = true;
                  return [
                    { text: item[5] || " ", alignment: "right", colSpan: 6, border },
                    "",
                    "",
                    "",
                    "",
                    "",
                    { text: item[6] || " ", alignment: "right", border },
                  ]}
                }
            ),
            [
              { text: " ", alignment: "center", border: [0, 1, 0, 0], colSpan:7 },
            ]
            ],
            
          },
        };
    reports("รายการชำระเงิน", obj, 14, "portrait");
  }

  render() {
    const {
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
      data,
      data_warehouse,
      data_bank,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการชำระเงิน</h4>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="บิลขาย, ชื่อลูกค้า, เบอร์โทร..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_payment_type: e.target.value });
                }}
                value={filter_payment_type}
              >
                <option value="">เลือกวิธีชำระเงิน</option>
                <option value="เงินสด">เงินสด</option>
                <option value="เงินโอน">เงินโอน</option>
                <option value="เครดิต/เช็ค">เครดิต/เช็ค</option>
              </select>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายการชำระเงิน"
                  sheet="รายการชำระเงิน"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>

            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่</td>
                    <td className="text-nowrap">เลขที่เอกสาร</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">จำนวนรวม</td>
                    <td className="text-nowrap">ภาษีมูลค่าเพิ่ม</td>
                    <td className="text-nowrap" colSpan={2}>จำนวนรวมทั้งสิ้น</td>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <>
                      <tr>
                        <td className="text-nowrap bg-primary-light">
                          {item.updated_at
                            ? format_date(
                                item.updated_at,
                                "dd/mm/yyyy hh:mm น."
                              )
                            : ""}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.document_no}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {item.warehouse?.name || "-"}
                        </td>
                        <td className="text-nowrap bg-primary-light">
                          {toFixed(item.amount)}
                        </td>
                        <td className="text-nowrap bg-primary-light"> {toFixed(
                            item.is_vat ? Number(item.amount) * 0.07 : 0
                          )}</td>
                        <td className="text-nowrap bg-primary-light" colSpan={2}>{toFixed(
                            Number(item.amount) +
                              (item.is_vat ? Number(item.amount) * 0.07 : 0)
                          )}</td>
                      </tr>
                      <tr>
                        <td className="text-nowrap fw-bold">ลำดับ</td>
                        <td className="text-nowrap fw-bold">ชื่อลูกค้า</td>
                        <td className="text-nowrap fw-bold">วิธีชำระเงิน</td>
                        <td className="text-nowrap fw-bold text-end">ธนาคาร</td>
                        <td className="text-nowrap fw-bold text-end">
                          เลขที่บัญชี
                        </td>
                        <td className="text-nowrap fw-bold text-end">
                          เลขที่เช็ค
                        </td>
                        <td className="text-nowrap fw-bold text-end">จำนวน</td>
                      </tr>
                      {item.transaction_list.map((tx, tx_index) => (
                        <tr>
                          <td className="text-nowrap">{tx_index + 1}</td>
                          <td className="text-nowrap">
                            {tx.sale?.customer?.full_name || "-"}
                          </td>
                          <td className="text-nowrap">
                            {Number(tx.cash_amount) !== 0
                              ? "สด"
                              : Number(tx.transfer_amount) !== 0
                              ? "โอน"
                              : Number(tx.credit_amount) !== 0
                              ? "เครดิต/เช็ค"
                              : ""}
                          </td>
                          <td className="text-nowrap text-end">
                            {tx.transfer_bank_account
                              ? data_bank?.find(
                                  (e) =>
                                    e.id === Number(tx.transfer_bank_account)
                                )?.bank_name
                              : tx.credit_bank_account}
                          </td>
                          <td className="text-nowrap text-end">
                            {
                              data_bank?.find(
                                (e) => e.id === Number(tx.transfer_bank_account)
                              )?.account_number
                            }
                          </td>
                          <td className="text-nowrap text-end">
                            {tx.check_number}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(tx.cash_amount) ||
                                Number(tx.transfer_amount) ||
                                Number(tx.credit_amount)
                            )}
                          </td>
                        </tr>
                      ))}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
